import UserModel from "@/models/UserModel";

export default class UsersState {
  users?: UserModel[];
}
